// packages block
import moment from "moment";
import { Dialog } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useReducer, useEffect } from "react";
// common block
import "./style.css";
import { preaddStyles } from "./styles";
import { FormButton } from "../form/button";
import { AddStudentForm } from "./addStudentForm";
import { PreDialogHeader } from "./preDialogHeader";
// constants, theme, utils and api block
import {
  validateAddStudentForm,
  validateAddStudentFormStepTwo,
  validateNumber,
} from "../../util/validation";
import { setAlert } from "../../redux/reducers/alert";
import { BLUE_EIGHT, ORANGE_TWO, WHITE } from "../../theme";
import {
  addStudent,
  studentProfileUpload,
  updateStudent,
} from "../../api/student";

export const AddStudentDialog = ({
  open,
  handleClose,
  title,
  payeeType,
  successCallback,
  isEditedItem,
  editSuccessCallback,
  showCircularProgressBar,
  getLatestCreateStudentId,
  edit = false,
  setEditPopup,
}) => {
  const classes = preaddStyles();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const { token, role } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];

  const [
    {
      studentRegNo,
      parentRegNo,
      firstName,
      lastName,
      grade,
      emiratesId,
      parentPhoneNumber,
      parentPassport,
      dob,
      schoolId,
      parentFirstName,
      parentLastName,
      parentGender,
      parentEmiratesId,
      parentCountryId,
      parentReligion,
      area,
      region,
      religion,
      streetAddress,
      email,
      phoneNumber,
      countryCode,
      countryCodeOtherNumber,
      otherNumber,
      // phoneNumberCode,
      // otherNumberCode,
      countryId,
      admissionDate,
      section,
      gender,
    },
    setData,
  ] = useReducer((state, newState) => ({ ...state, ...newState }), {
    studentRegNo: "",
    parentRegNo: "",
    firstName: "",
    lastName: "",
    grade: "",
    emiratesId: "",
    parentPhoneNumber: "",
    parentPassport: "",
    dob: "",
    schoolId: "",
    parentFirstName: "",
    parentLastName: "",
    parentGender: "",
    parentEmiratesId: "",
    parentCountryId: "",
    parentReligion: "",
    area: "",
    region: "",
    streetAddress: "",
    email: "",
    phoneNumber: "",
    countryCode: "",
    countryCodeOtherNumber: "",
    otherNumber: "",
    // phoneNumberCode: "",
    // otherNumberCode: "",
    religion: "",
    countryId: "",
    admissionDate: "",
    section: "",
    gender: "",
  });

  const [picValue, setPicValue] = useState("");

  useEffect(() => {
    if (isEditedItem) {
      setData({
        studentRegNo: isEditedItem.studentRegNo || "",
        parentRegNo: isEditedItem.parentRegNo || "",
        firstName: isEditedItem.firstName || "",
        lastName: isEditedItem.lastName || "",
        grade: isEditedItem.grade || "",
        emiratesId: isEditedItem.emiratesId || "",
        parentPhoneNumber: isEditedItem.parentPhoneNumber || "",
        dob: isEditedItem.dob || "",
        parentPassport: isEditedItem.parentPassport || "",
        schoolId: isEditedItem.schoolId || "",
        parentFirstName: isEditedItem.parentFirstName || "",
        parentLastName: isEditedItem.parentLastName || "",
        parentGender: isEditedItem.parentGender || "",
        parentEmiratesId: isEditedItem.parentEmiratesId || "",
        parentCountryId: isEditedItem.parentCountryId || "",
        parentReligion: isEditedItem.parentReligion || "",
        area: isEditedItem.area || "",
        region: isEditedItem.region || "",
        religion: isEditedItem.religion || "",
        streetAddress: isEditedItem.streetAddress || "",
        email: isEditedItem.email || "",
        phoneNumber: isEditedItem.phoneNumber || "",
        countryCode: isEditedItem.countryCode || "",
        countryCodeOtherNumber: isEditedItem.countryCodeOtherNumber || "",
        otherNumber: isEditedItem.otherNumber || "",
        countryId: isEditedItem.countryId || "",
        admissionDate: isEditedItem.admissionDate || "",
        section: isEditedItem.section || "",
        gender: isEditedItem.gender || "",
      });
    }
  }, [isEditedItem]);

  const [errors, setErrors] = useState([]);

  const handleChangePhone = (event, country) => {
    let validIt = validateNumber(event);
    if (validIt) {
      setData({
        phoneNumber: event,
        countryCode: country.dialCode,
      });
    }
  };
  const handleChangeParentPhone = (event, country) => {
    let validIt = validateNumber(event);
    if (validIt) {
      setData({
        otherNumber: event,
        countryCodeOtherNumber: country.dialCode,
      });
    }
  };
  const handlePersonalData = (prop) => (event) => {
    if (
      (prop === "phoneNumber" || prop === "otherNumber") &&
      event.target?.phc != undefined
    ) {
      setData({
        [prop]: event.target.value,
        [`${prop}Code`]: event.target.phc,
      });
    } else {
      setData({
        [prop]: event.target.value,
      });
    }

    if (errors.indexOf(prop) > -1) {
      const updatedErrors = [...errors];
      updatedErrors.splice(errors.indexOf(prop), 1);
      setErrors(updatedErrors);
    }
  };

  const handleContinue = () => {
    if (edit) {
      setEditPopup(false);
      if (isEditedItem) handleUpdation();
      else handleSubmission();
    }
    if (step === 1) {
      const validationResponse = validation(true);

      if (validationResponse.length > 0) {
        setErrors(validationResponse);
      } else {
        setStep(2);
      }
    } else {
      if (isEditedItem) handleUpdation();
      else handleSubmission();
    }
  };

  const stepUp = () => {
    if (step === 1) {
      const validationResponse = validation(true);
      if (validationResponse.length > 0) {
        setErrors(validationResponse);
        return;
      } else {
        setStep(2);
      }
    }
  };

  const stepDown = () => {
    if (step === 2) {
      setStep(1);
    } else {
      handleClose();
    }
  };

  const handleUpdation = async () => {
    const validationResponse = validation(false);

    if (validationResponse.length > 0) {
      setErrors(validationResponse);
      return;
    }

    try {
      setLoading(true);
      const payload = {
        studentRegNo,
        parentRegNo,
        firstName,
        lastName,
        grade,
        emiratesId,
        parentPhoneNumber,
        parentPassport,
        dob,
        schoolId,
        parentFirstName,
        parentLastName,
        parentGender,
        parentEmiratesId,
        parentCountryId,
        parentReligion,
        area,
        region,
        religion,
        streetAddress,
        email,
        phoneNumber,
        countryCode,
        countryCodeOtherNumber,
        otherNumber,
        countryId,
        admissionDate,
        section,
        gender,
      };
      const response = await updateStudent(isEditedItem.id, payload, token);

      if (response.status) {
        showSuccessAlert(t("text_student_updated_successfully"));
        local.push({
          message: "Student Updated successfully",
          date: new Date().getTime(),
          newNotification: true,
        });

        localStorage.setItem("notify", JSON.stringify(local));

        if (picValue !== "") {
          const formData = new FormData();
          formData.append("file", picValue);
          const response = await studentProfileUpload(
            formData,
            isEditedItem.id
          );
        }
        editSuccessCallback(response.student);
        handleClose();
      } else {
        showErrorAlert(
          response.message ||
            t("text_error_in_updating_student_please_try_again")
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || t("text_error_in_updating_student_please_try_again")
      );
    }
  };

  const validation = (value) =>
    validateAddStudentForm(
      // value,
      firstName,
      lastName,
      dob,
      email,
      phoneNumber
    );
  let payeeId = "";
  const validationStepTwo = (value) =>
    validateAddStudentFormStepTwo(
      (payeeId = payeeType === "STUDENT" ? studentRegNo : parentRegNo),
      admissionDate
    );

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  let date = new Date();
  date = moment(date).format("YYYY-MM-DD");

  const handleSubmission = async () => {
    const validationResponse = validationStepTwo(true);
    if (validationResponse.length > 0) {
      setErrors(validationResponse);
      return;
    }
    const removeNonDigitPhoneNumber = phoneNumber.replace(/\D/g, "");
    const regexPhoneNumber = new RegExp(countryCode, "g");
    const customPhoneNumber = removeNonDigitPhoneNumber.replace(
      regexPhoneNumber,
      ""
    );
    const removeNonDigitOtherNumber = otherNumber.replace(/\D/g, "");
    const regexOtherNumber = new RegExp(countryCodeOtherNumber, "g");
    const customOtherNumber = removeNonDigitOtherNumber.replace(
      regexOtherNumber,
      ""
    );

    try {
      setLoading(true);
      const payload = {
        studentRegNo,
        parentRegNo,
        firstName,
        lastName,
        grade,
        emiratesId,
        parentPhoneNumber,
        schoolId: 6,
        parentFirstName,
        parentLastName,
        parentGender,
        parentEmiratesId,
        parentCountryId,
        parentReligion,
        area,
        region,
        religion,
        streetAddress,
        email,
        phoneNumber: customPhoneNumber,
        countryCode,
        otherNumber: customOtherNumber,
        countryCodeOtherNumber,
        countryId,
        section,
        gender,
        parentPassport,
        dob,
        admissionDate,
      };

      if (dob !== "") {
        payload.dob = dob;
      }

      if (admissionDate !== "") {
        payload.admissionDate = admissionDate;
      }

      const { status, message, student } = await addStudent(payload, token);
      if (status) {
        showSuccessAlert(t("text_students_added_successfully"));
        local.push({
          message: "Student added successfully",
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
        successCallback(student);
        getLatestCreateStudentId(student.id);

        if (picValue !== "") {
          const formData = new FormData();
          formData.append("file", picValue);
          const response = await studentProfileUpload(formData, student.id);
        }

        handleClose();
      } else {
        showErrorAlert(
          message || t("text_error_in_adding_student_please_try_again")
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || t("text_error_in_adding_student_please_try_again")
      );
    }
  };

  return (
    <Dialog
      className={classes.root}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div className={classes.mainContainer}>
        <PreDialogHeader
          title={title}
          handleClose={handleClose}
          showCircularProgressBar={showCircularProgressBar}
          step={step}
          stepUp={stepUp}
          stepDown={stepDown}
          backbut={true}
        />

        <div className={classes.dropContainer}>
          <AddStudentForm
            studentRegNo={studentRegNo}
            parentRegNo={parentRegNo}
            firstName={firstName}
            lastName={lastName}
            grade={grade}
            emiratesId={emiratesId}
            parentPhoneNumber={parentPhoneNumber}
            parentPassport={parentPassport}
            dob={dob}
            schoolId={schoolId}
            parentFirstName={parentFirstName}
            parentLastName={parentLastName}
            parentGender={parentGender}
            parentEmiratesId={parentEmiratesId}
            parentCountryId={parentCountryId}
            parentReligion={parentReligion}
            area={area}
            region={region}
            religion={religion}
            streetAddress={streetAddress}
            email={email}
            phoneNumber={phoneNumber}
            otherNumber={otherNumber}
            countryId={countryId}
            admissionDate={admissionDate}
            section={section}
            gender={gender}
            errors={errors}
            handlePersonalData={handlePersonalData}
            handleChangePhone={handleChangePhone}
            handleChangeParentPhone={handleChangeParentPhone}
            step={step}
            setPicValue={setPicValue}
            payeeType={payeeType}
          />
        </div>

        <div className={classes.addSchooldialogFooter}>
          <div className={classes.footerButton}>
            <FormButton
              title={t("text_cancel")}
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              backgroundColor={ORANGE_TWO}
              borderColor={ORANGE_TWO}
              titleColor={WHITE}
              hoverBackgroundColor={WHITE}
              hoverBorderColor={ORANGE_TWO}
              hoverTitleColor={ORANGE_TWO}
              onClickHandler={handleClose}
              style={{
                fontSize: "0.8vw",
                fontWeight: "700",
                textTransform: "capitalize",
              }}
            />
          </div>

          <div className={classes.footerButton}>
            {role === "superadmin" ? (
              ""
            ) : (
              <FormButton
                title={step === 1 ? t("text_continue") : t("text_confirm")}
                onClickHandler={handleContinue}
                height={40}
                width={"10vw"}
                borderTopRightRadius={15}
                borderTopLeftRadius={15}
                borderBottomLeftRadius={15}
                borderBottomRightRadius={15}
                backgroundColor={BLUE_EIGHT}
                titleColor={WHITE}
                hoverTitleColor={BLUE_EIGHT}
                hoverBackgroundColor={WHITE}
                hoverBorderColor={BLUE_EIGHT}
                step={step}
                loading={loading}
                style={{
                  fontSize: "0.8vw",
                  fontWeight: "700",
                  textTransform: "capitalize",
                }}
              />
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};
